import { useEffect, useRef } from 'react';

export function useDidUpdate(fn, deps) {
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      fn();
    }
  }, deps);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
}



// WEBPACK FOOTER //
// src/hooks/use-did-update.js